// components
import { DateTime } from 'luxon';
import { saveAs } from 'file-saver';
// types
import { ILedgerTableFilters } from '../../types/accounting';
import { BookkeepingService } from '../../api';

// ----------------------------------------------------------------------

export const FileExportSIE = async (filters: ILedgerTableFilters) => {
  const result = await BookkeepingService.exportSie({
    fromDate: filters.fromDate ?? DateTime.now(),
    toDate: filters.toDate ?? DateTime.now(),
  });

  const blob = new Blob([result], {
    type: 'text/plain',
  });
  saveAs(
    blob,
    `ledger_${filters.fromDate!.toFormat('yyyy-MM-dd')}__${filters.toDate!.toFormat(
      'yyyy-MM-dd'
    )}.SI`
  );
};
